import { render } from "./ClientPage.vue?vue&type=template&id=6dad4da2&scoped=true"
import script from "./ClientPage.vue?vue&type=script&lang=js"
export * from "./ClientPage.vue?vue&type=script&lang=js"

import "./ClientPage.vue?vue&type=style&index=0&id=6dad4da2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dad4da2"]])

export default __exports__